export default __webpack_public_path__ + "static/media/rank-badge.fa642408.png";